// extracted by mini-css-extract-plugin
export var primitiveLabel = "_tz-0";